export class ContractModel {
  contracts?: [];

  constructor() {
    this.contracts = [];
  }
}
